import { render, staticRenderFns } from "./XuSelect.vue?vue&type=template&id=4901731a&scoped=true"
import script from "./XuSelect.vue?vue&type=script&lang=js"
export * from "./XuSelect.vue?vue&type=script&lang=js"
import style0 from "./XuSelect.vue?vue&type=style&index=0&id=4901731a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4901731a",
  null
  
)

export default component.exports